<template>
  <div style="margin: 20px">
    <van-form>
      <van-field
          readonly
          clickable
          name="picker"
          :value="Info.Leave_Type_Name"
          label="请假类型"
        />
      <van-field
        readonly
        clickable
        name="datetimeStart"
        :value="Info.datetimeStart"
        label="开始时间"
        placeholder="点击选择时间"
        :formatter="formatter"
        @click="showPickerStart = true"
      />
      <van-popup v-model="showPickerStart" position="bottom">
        <van-datetime-picker
            v-model="currentDateStart"
            type="date"
            @confirm="onConfirmStart"
            @cancel="showPickerStart = false"
            :formatter="formatter"
        />
      </van-popup>
      <van-field
          readonly
          clickable
          name="datetimeEnd"
          :value="Info.datetimeEnd"
          label="结束时间"
          placeholder="点击选择时间"
          @click="showPickerEnd = true"
      />
      <van-popup v-model="showPickerEnd" position="bottom">
        <van-datetime-picker
          v-model="currentDateEnd"
          type="date"
          @confirm="onConfirmEnd"
          @cancel="showPickerEnd = false"
          :formatter="formatter"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        label="时长"
        :value="Info.DayValue"
        placeholder="请选择请假时长"
        @click="showPicker = true"
      />
      <van-popup v-model="showPicker" round position="bottom">
        <van-picker
            show-toolbar
            :columns="columns"
            @cancel="showPicker = false"
            @confirm="onConfirm"
        />
      </van-popup>
      <van-field
          v-model="Info.Subject"
          label="请假原因"
          type="textarea"
          placeholder="请输入请假原因"
      />

      <van-cell-group v-for="(item,index) in ADTList" :key="index">
        <van-cell :title="item.ADT_Header" :label="item.Date_ADT_Show" :value="item.ADT_Views" />
      </van-cell-group>
      <div style="margin: 16px;">
        <van-button round block type="info" @click="onSubmit">提交</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import {GetLeaveAddInfo, GetLeaveInfo, LeaveConfirm, LeaveADTInfo} from "@/api/leave";
import store from "@/store";
import moment from "moment-timezone";
import {Dialog, Toast} from "vant";
import {Emas} from "@/assets/js/Emas";

export default {
  name: "leaveConfirm",
  data() {
    return {
      UserID: '',
      token: '',
      IST_ID:'',
      SEQ_ID:'',
      Node_ID:'',
      Leave_ID: '',
      Info:{
        Leave_Type_ID: null,
        Leave_Type_Name: null,
        datetimeStart: null,
        datetimeEnd: null,
        Day:'',
        DayValue: '',
        Subject: '',
      },
      columns: [],
      ADTList:[],
      showPickerStart: false,
      showPickerEnd: false,
      showPicker: false,
      currentDateStart: new Date(),
      currentDateEnd: new Date()

    }
  },
  created() {
    this.Leave_ID = this.$route.query.PK_Value
    this.IST_ID = this.$route.query.IST_ID
    this.SEQ_ID = this.$route.query.SEQ_ID
    this.Node_ID = this.$route.query.Node_ID
    this.UserID = store.getters["User_ID"];
    this.token = store.getters["token"];
    this.fetchData()
    let Staff_Name = sessionStorage.getItem("Staff_Name");
    let DD_ID = sessionStorage.getItem("DD_ID");
    Emas(Staff_Name, DD_ID,"leaveConfirm", "完假确认", "yywjjoa.yy.gov.cn/leaveConfirm")
  },
  methods:{
    async fetchData() {
      await this.GetLeaveInfo()
      await this.GetLeaveAddInfo()
      await this.LeaveADTInfo()
    },

    //获取详情信息
    async GetLeaveInfo(){
      Toast.loading({
        duration: 0, // 持续展示 toast
        message: '正在加载',
        forbidClick: true,
      });
      const {data} = await GetLeaveInfo({Leave_ID:this.Leave_ID, token:this.token})
      Toast.clear();
      if (data.code === 200) {
        let obj = data.data
        this.Info = {
          Leave_Type_ID: obj.Leave_Type_ID,
          Leave_Type_Name: obj.Leave_Type,
          datetimeStart: obj.Date_Start,
          datetimeEnd: obj.Date_End,
          Day: obj.Total.substring(0, obj.Total.length - 1),
          DayValue: obj.Total,
          Subject: obj.Subject,
        }
        this.currentDateStart = new Date(Number(moment(obj.Date_Start).format('yyyy')), Number(moment(obj.Date_Start).format('MM')) - 1, Number(moment(obj.Date_Start).format('DD')))
        this.currentDateEnd = new Date(Number(moment(obj.Date_End).format('yyyy')), Number(moment(obj.Date_End).format('MM')) - 1, Number(moment(obj.Date_End).format('DD')))
      }
    },

    //获取请假详情基础数据
    async GetLeaveAddInfo() {
      let obj = {
        UserID : this.UserID,
        token : this.token
      }
      const {data} = await GetLeaveAddInfo(obj)
      if (data.code === 200) {
        this.columns = data.data.Time
      }
    },

    //获取审批信息
    async LeaveADTInfo() {
      let obj = {
        token : this.token,
        Leave_ID : this.Leave_ID,
      }
      const {data} = await  LeaveADTInfo(obj)
      if(data.code === 200) {
        this.ADTList = data.data
      }else {
        this.ADTList = []
      }
    },

    async onSubmit() {
      let obj = {
        token: this.token,
        UserID: this.UserID,
        IST_ID: this.IST_ID,
        SEQ_ID: this.SEQ_ID,
        Node_ID: this.Node_ID,
        Leave_ID: this.Leave_ID,
        Subject: this.Info.Subject,
        Day: this.Info.Day,
        datetimeStart: this.Info.datetimeStart,
        datetimeEnd: this.Info.datetimeEnd,
        Leave_Type_ID: this.Info.Leave_Type_ID,
      }
      const {data} = await LeaveConfirm(obj)
      if (data.code === 200) {
        Dialog.alert({
          message: data.msg,
        }).then(() => {
          this.$router.replace('/dbrw')
        });
      }
    },

    //格式化时间
    formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }else if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },

    onConfirmType(value, index) {
      this.Info.Leave_Type_ID = index + 1
      this.Info.Leave_Type_Name = value
      this.showPickerType = false;
    },
    //开始时间选择器
    onConfirmStart(time) {
      this.Info.datetimeStart = moment(time).format('yyyy-MM-DD');
      this.showPickerStart = false;
    },
    //结束时间选择器
    onConfirmEnd(time) {
      this.Info.datetimeEnd = moment(time).format('yyyy-MM-DD');
      this.showPickerEnd = false;
    },
    //请假时长
    onConfirm(value) {
      this.Info.Day = value;
      this.Info.DayValue = value + "天"
      this.showPicker = false;
    },
  }
}
</script>

<style scoped>

  .van-cell__value {
    color: #323233;
  }
</style>